import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDynamicTable, renderReportfield} from '../../utils/templateUtils';
import './seventhMonthICSI.scss';

export default function SeventhMonthICSI(props) {
  // Ectopic Table State and Headers (exactly as FifthMonthPregnancy)
  const [ectopicRows, setEctopicRows] = useState([
    {
      outcome: '',
      conception: '',
      weeks: '',
      delivery: '',
      baby: '',
      complications: '',
      comments: ''
    }
  ]);
  const ecTopicHeaders = [
    {key: 'outcome', label: 'G Outcome', inputType: 'select', options: ['Term', 'Preterm', 'Miscarriage', 'Ectopic']},
    {key: 'conception', label: 'Mode of Conception', inputType: 'select', options: ['Natural', 'IUI', 'IVF']},
    {key: 'weeks', label: 'Weeks'},
    {key: 'delivery', label: 'Mode of Delivery', inputType: 'select', options: ['Vaginal', 'LSCS', 'Medical', 'Surgical Miscarriage']},
    {key: 'baby', label: 'Baby Outcome', inputType: 'select', options: ['Alive', 'Expired', 'Other']},
    {key: 'complications', label: 'Complications', inputType: 'select', options: ['BP', 'DM', 'BT', 'ICU', 'Nil', 'Other']},
    {key: 'comments', label: 'COMMENTS'}
  ];
  const [showTables, setShowTables] = useState({
    medication: true,
    test: true,
    ecTopic: true
  });
  const [formData, setFormData] = useState({
    picmeNumber: ''
  });
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [testRows, setTestRows] = useState([
    {
      test: 'Anomaly Scan',
      result: ''
    },
    {
      test: 'Fetal Echo',
      result: ''
    }
  ]);

  const testHeaders = [
    {key: 'test', label: 'INVESTIGATION'},
    {key: 'result', label: 'DATE'}
  ];

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: '1',
      drug: 'Globac XT / Ferronomic Plus / Furnext',
      genericName: 'Ferrous Ascorbate + Folic Acid',
      dosage: '1 tablet',
      freq: '0-1-0',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days',
      remarks: 'Avoid tea/coffee; not with calcium'
    },
    {
      sno: '2',
      drug: 'Tricium XT / Ultra Ca',
      genericName: 'Calcium Citrate + Vitamin D3',
      dosage: '1 tablet',
      freq: '1-0-1',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days',
      remarks: '4-hour gap from iron'
    },
    {
      sno: '3',
      drug: 'Folvista / Cor 3 / MecobMB',
      genericName: 'L-Methylfolate + Pyridoxine + Cyanocobalamin',
      dosage: '1 tablet',
      freq: '0-1-0',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days',
      remarks: '—'
    },
    {
      sno: '4',
      drug: 'C-Vit / Celin',
      genericName: 'Vitamin C',
      dosage: '500 mg',
      freq: '0-1-0',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days',
      remarks: 'Take along with iron'
    },
    {
      sno: '5',
      drug: 'Neuroplex / Neurobion',
      genericName: 'Vitamin B-complex',
      dosage: '1 tablet',
      freq: 'OD',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days',
      remarks: 'Hemoglobin support'
    },
    {
      sno: '6',
      drug: 'Vivamom (Sugar free)',
      genericName: 'Protein + DHA + Multivitamins',
      dosage: '2 tsp',
      freq: 'OD/BD',
      route: 'Oral (with milk)',
      timing: 'Morning & Night',
      duration: '30 days',
      remarks: 'Optional supplement'
    },
    {
      sno: '7',
      drug: 'Strone AQ / Aqgest',
      genericName: 'Progesterone',
      dosage: '50 mg',
      freq: '1-0-0',
      route: 'SC / IM',
      timing: 'Morning',
      duration: 'As advised',
      remarks: 'Continue based on plan'
    },
    {
      sno: '8',
      drug: 'Gufigest / Gestobond',
      genericName: 'Micronized Progesterone',
      dosage: '400 mg',
      freq: '0-0-1 / BD',
      route: 'Vaginal',
      timing: 'Night',
      duration: '30 days',
      remarks: 'Insert after washing hands'
    },
    {
      sno: '9',
      drug: 'Candid CL / Cansoft CL',
      genericName: 'Clindamycin + Clotrimazole',
      dosage: '1 pessary',
      freq: 'OD',
      route: 'Vaginal',
      timing: 'Afternoon',
      duration: '3 days/month',
      remarks: 'If discharge/irritation'
    },
    {
      sno: '10',
      drug: 'Ecospirin 75/150',
      genericName: 'Aspirin',
      dosage: '75 / 150 mg',
      freq: '0-1-0',
      route: 'Oral',
      timing: 'After food',
      duration: 'Till 34 weeks',
      remarks: '—'
    },
    {
      sno: '11',
      drug: 'Evaparin / Lonopin',
      genericName: 'Enoxaparin',
      dosage: '0.4 / 0.6 ml',
      freq: '1-0-0',
      route: 'SC',
      timing: 'Morning',
      duration: 'As advised',
      remarks: 'Anticoagulant'
    },
    {
      sno: '12',
      drug: 'Glycomet SR',
      genericName: 'Metformin',
      dosage: '500 mg',
      freq: '1-0-1 / OD',
      route: 'Oral',
      timing: 'After food',
      duration: 'As advised',
      remarks: 'Insulin resistance / GDM'
    },
    {
      sno: '13',
      drug: 'Thyronorm',
      genericName: 'Levothyroxine (as per TSH)',
      dosage: '1 tablet',
      freq: '1-0-0',
      route: 'Oral',
      timing: 'Empty stomach',
      duration: 'As advised',
      remarks: 'No food 30 min'
    },
    {
      sno: '14',
      drug: 'Influvac Tetra',
      genericName: 'Quadrivalent Influenza Vaccine',
      dosage: '0.5 ml',
      freq: 'Single dose',
      route: 'IM',
      timing: '—',
      duration: 'Once (seasonal)',
      remarks: '—'
    },
    {
      sno: '15',
      drug: 'V-Wash',
      genericName: 'pH-balanced cleanser',
      dosage: 'Coin-size',
      freq: 'PRN',
      route: 'External',
      timing: '—',
      duration: '—',
      remarks: 'Hygiene support'
    }
  ]);

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Drug Name'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dosage', label: 'Dose'},
    {key: 'freq', label: 'Frequency'},
    {key: 'route', label: 'Route'},
    {key: 'timing', label: 'Timing'},
    {key: 'duration', label: 'Duration'},
    {key: 'remarks', label: 'Remarks'}
  ];

  const handleChange = e => {
    var text = e.target.value;

    if (e.target.name === 'patientId') {
     if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || '').trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            if (e.target.name === 'patientId') {
              setFormData({
                ...formData,
                patientName: namePat,
                age: data?.age,
                gender: data?.gender,
                patientId: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId') {
          setFormData({
            ...formData,
            patientId: e.target.value
          });
        }
      }
    } else {
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const handlesubmit = () => {
    try {
       if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('seventhMonthICSIReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'ICSI 7 th Month',
              picme_number: formData.picmeNumber,
              status: formData.picmeStatus
            }
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  useEffect(() => {
    if (props.patientsData.picme_number) {
      setFormData(prev => ({...prev, picmeNumber: props.patientsData.picme_number, picmeStatus: 'Already Given'}));
    }
  }, [props.patientsData.picme_number]);

  return (
    <div id='SeventhMonthICSITemplate'>
      <div className='SeventhMonthICSITemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>ICSI 7th Month – ASCAS</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <h3 className='mt-3'>OBSTETRIC SCORE :</h3>
          <div className='row'>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='G:' name='g' value={formData.g} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='P:' name='p' value={formData.p} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='A:' name='a' value={formData.a} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='L:' name='l' value={formData.l} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='E:' name='ecTopic' value={formData.ecTopic} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>

          {showTables.ecTopic && (
            <TemplateTable
              id='ecTopic'
              title=''
              headers={ecTopicHeaders}
              rows={ectopicRows}
              onRowsChange={(id, newRows) => setEctopicRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('ecTopic', setShowTables)}
            />
          )}
          <div className='row'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel
                label='Period of Gestation (POG):'
                name='pog'
                value={formData.pog}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='Weeks'
                minWidth='250px'
              />
            </div>
          </div>
          <div className='d-flex align-items-start py-2'>
            <label htmlFor='scanFinding' className='fw-bold' style={{width: '180px'}}>
              🖥️ SCAN FINDINGS:
            </label>
            <textarea className='Textarea' placeholder='Scan Findings' id='scanFinding' name='scanFinding' onChange={handleChange} rows='3' cols='100' />
          </div>
          <div className='d-flex align-items-start py-2'>
            <label htmlFor='complaints' className='fw-bold' style={{width: '180px'}}>
              Complaints:
            </label>
            <textarea className='Textarea' placeholder='Complaints' id='complaints' name='complaints' onChange={handleChange} rows='3' cols='100' />
          </div>

          <h3 className='mt-3'>🩺 On Examination (O/E)</h3>
          <div className='row'>
            <div className='col-md-4'>
              <SelectField
                label='Pallor'
                name='pallor'
                value={formData.pallor}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <SelectField
                label='Pedal Edema'
                name='pedalEdema'
                value={formData.pedalEdema}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Pulse Rate (PR):' name='pulse' value={formData.pulse} required={false} onChange={handleChange} inputClassName='show' endLabel='bpm' minWidth='160px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='BP:' name='bp' value={formData.bp} required={false} onChange={handleChange} inputClassName='show' endLabel='mmHg' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Weight:' name='weight' value={formData.weight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Previous Visit Weight:'
                name='previousWeight'
                value={formData.previousWeight}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='kg'
                minWidth='200px'
              />
            </div>
          </div>
          <div className='d-flex align-items-start py-2'>
            <label htmlFor='perAbdomen' className='fw-bold' style={{width: '180px'}}>
              Per Abdomen (P/A):
            </label>
            <textarea className='Textarea' placeholder='Uterus 28–30 weeks, relaxed, liquor average, FHS good' id='perAbdomen' name='perAbdomen' onChange={handleChange} rows='3' cols='100' />
          </div>
        </div>

        <div className='row py-3'>
          {showTables.medication && (
            <TemplateTable
              id='medication'
              title='💊 ANTENATAL MEDICATION CHART – 7 MONTHS ICSI'
              headers={medicationHeaders}
              rows={medicationRows}
              onRowsChange={(id, newRows) => setMedicationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('medication', setShowTables)}
            />
          )}
        </div>
        <div className='bulletin mt-3'>
          <h4>🧪 Investigations Before Next Visit</h4>
          <ul className='ms-5 mb-0 pb-0'>
            <li>Ultrasound: Growth + Liquor Scan</li>
            <li>
              <div className='d-flex align-items-start py-2'>
                <label htmlFor='bloodTest' className='fw-bold' style={{width: '130px'}}>
                  Blood Tests:
                </label>
                <textarea className='Textarea' placeholder='' id='bloodTest' name='bloodTest' onChange={handleChange} rows='1' cols='75' />
              </div>
            </li>
          </ul>

          <div className='row'>
            <div className='col-md-4 pb-2'>
              <SelectField
                label='📝 PICME Number'
                name='picmeStatus'
                value={formData.picmeStatus}
                options={[
                  {label: 'Registered', value: 'Registered'},
                  {label: 'Not Registered', value: 'Not Registered'},
                  {label: 'Already Given', value: 'Already Given'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
                minWidth='160px'
              />
            </div>
            {formData.picmeStatus === 'Registered' && (
              <div className='col-md-6'>
                <ReportFormInputWithLabel label='Enter PICME Number:' name='picmeNumber' value={formData.picmeNumber} required={false} onChange={handleChange} inputClassName='show' minWidth='200px' />
              </div>
            )}
            {formData.picmeStatus === 'Already Given' && <div className='col-md-6 me-2 mt-3 fw-bold'>{formData.picmeNumber}</div>}
          </div>

          <div className='bulletin mt-3'>
            <h4>👣 Fetal Movements</h4>

            <p>Fetal movements should be felt daily. Just perceiving is enough.</p>
            <p>If you feel movements are reduced, lie on your side, eat something sweet, and observe.</p>
          </div>
        </div>

        <div className='bulletin'>
          <h4>Tips for 7th Month Pregnancy</h4>
          <ol className='px-3'>
            <li>Practice prenatal yoga for 20–30 minutes daily to improve flexibility and circulation (avoid lying flat or overstretching).</li>
            <li>Pelvic tilts and cat-cow stretches help relieve backache and improve posture.</li>
            <li>Walking for 20–30 minutes daily improves blood flow and reduces leg swelling.</li>
            <li>Use a birthing ball (exercise ball) for gentle pelvic rocking to ease pressure on the lower back.</li>
            <li>Always do exercises under trained supervision and stop immediately if you feel dizzy, breathless, or unwell.</li>
            <li>
              👉 Watch second trimester video by Dr. Aishwarya on Doctor Mommies YouTube:
              <br />
              <a href='https://www.youtube.com/watch?v=ejdW9akItdw' target='_blank' rel='noopener noreferrer'>
                Second Trimester – Doctor Mommies
              </a>
            </li>
          </ol>
        </div>

        <div className='bulletin'>
          <h4>✅ ஏழாம் மாத கர்ப்பகால குறிப்புகள்</h4>
          <ol className='px-3'>
            <li>மாதவிடாய் யோகா (prenatal yoga) தினமும் 20–30 நிமிடங்கள் செய்யுங்கள் – இது உடல் நெகிழ்வை மற்றும் இரத்த ஓட்டத்தை மேம்படுத்தும்.</li>
            <li>பெல்விக் டில்ட், காட்-காவ் ஸ்ட்ரெட்ச் போன்ற யோகா பயிற்சிகள் முதுகு வலிக்கு நல்லது.</li>
            <li>தினமும் 20–30 நிமிடங்கள் நடப்பது கால்வலி மற்றும் வீக்கத்தை குறைக்கும்.</li>
            <li>பர்திங் பால் பயன்படுத்தி மென்மையான உடல் ஆட்டங்கள் செய்வது கீழ் வயிற்று அழுத்தத்தை குறைக்கும்.</li>
            <li>பயிற்சி செய்யும் போது எந்த வலியையும் உணர்ந்தால் உடனே நிறுத்தவும். பயிற்சியை வல்லுநர் கண்காணிப்பில் செய்ய வேண்டும்.</li>
            <li>
              👉 டாக்டர் ஐஸ்வர்யா வழங்கும் Doctor Mommies YouTube வீடியோவை பாருங்கள்:
              <br />
              <a href='https://www.youtube.com/watch?v=ejdW9akItdw' target='_blank' rel='noopener noreferrer'>
                நடுத்தர கர்ப்ப காலம் – Doctor Mommies
              </a>
            </li>
          </ol>
        </div>

        <div className='d-flex align-items-start py-2' style={{gap: '10px'}}>
          <label htmlFor='additionalAdvice' className='fw-bold' style={{whiteSpace: 'nowrap', paddingTop: '6px'}}>
            Advice:
          </label>
          <textarea className='Textarea' placeholder='add advice' id='additionalAdvice' name='additionalAdvice' onChange={handleChange} rows='4' cols='100' />
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='seventhMonthICSIReport'>
        <div id='seventhMonthICSIReportWrap'>
          <Headers />
          <p className='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '5px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>ICSI 7th Month – ASCAS</h4>
          </div>
          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>OBSTETRIC SCORE :</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('G:', formData.g)}
            {renderReportfield('P:', formData.p)}
            {renderReportfield('A:', formData.a)}
            {renderReportfield('L:', formData.l)}
            {renderReportfield('E:', formData.ecTopic)}
          </div>
          {showTables.ecTopic &&
            renderDynamicTable(
              '',
              ['G Outcome', 'Mode of Conception', 'Weeks', 'Mode of Delivery', 'Baby Outcome', 'Complications', 'COMMENTS'],
              ['outcome', 'conception', 'weeks', 'delivery', 'baby', 'complications', 'comments'],
              ectopicRows
            )}
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>{renderReportfield('Period of Gestation (POG):', `${formData.pog ? formData.pog : ''} Weeks`)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('🖥️ SCAN FINDINGS:', formData.scanFinding)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Complaints:', formData.complaints)}</div>

          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>🩺 On Examination (O/E)</h6>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Pallor:', formData.pallor)}
            {renderReportfield('Pedal Edema:', formData.pedalEdema)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Pulse Rate (PR):', `${formData.pulse ? formData.pulse : ''} bpm`)}
            {renderReportfield('BP:', `${formData.bp ? formData.bp : ''} mmHg`)}
            {renderReportfield('Weight:', `${formData.weight ? formData.weight : ''} kg`)}
            {renderReportfield('Previous Visit Weight:', `${formData.previousWeight ? formData.previousWeight : ''} kg`)}
            {renderReportfield('Per Abdomen (P/A):', formData.perAbdomen)}
          </div>

          {showTables.medication &&
            renderDynamicTable(
              '💊 ANTENATAL MEDICATION CHART – 7 MONTHS ICSI',
              ['S.No', 'Drug Name', 'Generic Name', 'Dose', 'Frequency', 'Route', 'Timing', 'Duration', 'Remarks'],
              ['sno', 'drug', 'genericName', 'dosage', 'freq', 'withFood', 'timing', 'duration', 'remarks'],
              medicationRows
            )}

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>🧪 Investigations Before Next Visit</h6>
          </div>
          {[`Ultrasound: Growth + Liquor Scan`, `Blood Tests: ${formData.bloodTest ? formData.bloodTest : ''}`].map((item, index) => (
            <div key={index} style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield(item, '', {styleSec: {width: '100%'}})}
            </div>
          ))}
          <div style={{display: 'flex', marginTop: '5px', marginLeft: '-10px'}}>
            {formData.picmeStatus === 'Registered' || formData.picmeStatus === 'Already Given'
              ? renderReportfield('📝 PICME Number:', formData.picmeNumber)
              : renderReportfield('📝 PICME Number:', formData.picmeStatus)}
          </div>

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>👣 Fetal Movements</h6>
          </div>
          <div style={{display: 'flex', marginTop: '0px'}}>
            <h6 style={{fontWeight: 600, marginLeft: '10px'}}>Fetal movements should be felt daily. Just perceiving is enough.</h6>
          </div>
          <div style={{display: 'flex', marginTop: '0px'}}>
            <h6 style={{fontWeight: 600, marginLeft: '10px'}}>If you feel movements are reduced, lie on your side, eat something sweet, and observe.</h6>
          </div>
          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>Tips for 7th Month Pregnancy</h6>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
            <div>
              {[
                '1. Practice prenatal yoga for 20–30 minutes daily to improve flexibility and circulation (avoid lying flat or overstretching).',
                '2. Pelvic tilts and cat-cow stretches help relieve backache and improve posture.',
                '3. Walking for 20–30 minutes daily improves blood flow and reduces leg swelling.',
                '4. Use a birthing ball (exercise ball) for gentle pelvic rocking to ease pressure on the lower back.',
                '5. Always do exercises under trained supervision and stop immediately if you feel dizzy, breathless, or unwell.',
                '👉 Watch second trimester video by Dr. Aishwarya on Doctor Mommies YouTube:',
                '<a href="https://www.youtube.com/watch?v=ejdW9akItdw" target="_blank" rel="noopener noreferrer">Second Trimester – Doctor Mommies</a>'
              ].map((item, index) => (
                <div key={index} style={{display: 'flex', marginBottom: '5px', paddingLeft: '10px'}} dangerouslySetInnerHTML={{__html: item}}></div>
              ))}
            </div>
          </div>

          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>✅ ஏழாம் மாத கர்ப்பகால குறிப்புகள்</h6>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
            <div>
              {[
                '1. மாதவிடாய் யோகா (prenatal yoga) தினமும் 20–30 நிமிடங்கள் செய்யுங்கள் – இது உடல் நெகிழ்வை மற்றும் இரத்த ஓட்டத்தை மேம்படுத்தும்.',
                '2. பெல்விக் டில்ட், காட்-காவ் ஸ்ட்ரெட்ச் போன்ற யோகா பயிற்சிகள் முதுகு வலிக்கு நல்லது.',
                '3. தினமும் 20–30 நிமிடங்கள் நடப்பது கால்வலி மற்றும் வீக்கத்தை குறைக்கும்.',
                '4. பர்திங் பால் பயன்படுத்தி மென்மையான உடல் ஆட்டங்கள் செய்வது கீழ் வயிற்று அழுத்தத்தை குறைக்கும்.',
                '5. பயிற்சி செய்யும் போது எந்த வலியையும் உணர்ந்தால் உடனே நிறுத்தவும். பயிற்சியை வல்லுநர் கண்காணிப்பில் செய்ய வேண்டும்.',
                '👉 டாக்டர் ஐஸ்வர்யா வழங்கும் Doctor Mommies YouTube வீடியோவை பாருங்கள்:',
                '<a href="https://www.youtube.com/watch?v=ejdW9akItdw" target="_blank" rel="noopener noreferrer">நடுத்தர கர்ப்ப காலம் – Doctor Mommies</a>'
              ].map((item, index) => (
                <div key={index} style={{display: 'flex', marginBottom: '5px', paddingLeft: '10px'}} dangerouslySetInnerHTML={{__html: item}}></div>
              ))}
            </div>
          </div>

          <div style={{marginBottom: '5px'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>ADVICE:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.additionalAdvice}</pre>
          </div>

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p className='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
